class MenuController {

    constructor() {
        var that = this;
        that.body = jQuery('body');
        that.header = jQuery('.main-header');
        that.button = that.header.find('#toggler-menu-mobile');
        that.active = false;

        that.button.on('click', function (e) {
            e.preventDefault();
            that.toggle();
        });
    }

    toggle() {
        if (this.active) this.close();
        else this.open();
    }

    open() {
        this.active = true;
        this.header.addClass('-open');
        this.body.addClass('menu-open');
    }

    close() {
        this.active = false;
        this.header.removeClass('-open');
        this.body.removeClass('menu-open');
    }

}
